module.exports = __webpack_public_path__ + "static/img/sectigo-siteseal@3x.2714ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/sectigo-siteseal@3x.png
// module id = 1813
// module chunks = 1